import { RouteObject } from "react-router-dom";

import CustomerMainLayout from "../../layouts/CustomerLayout/CustomerMainLayout";
import CheckoutLayout from "../../layouts/CustomerLayout/CheckoutLayout";

import CustomerPrivateRoute from "./CustomerPrivateRoute";
import CustomerAuthRoute from "./CustomerAuthRoute";

// ----------------------------------------------------
// Customer
// ----------------------------------------------------

import CustomerDashboard from "../../modules/customer/customerdashboard";

import CustomerNewProductDetailsPage from "../../modules/customer/CustomerInDetailsPage/CustomerNewProductDetailsPage";
import PetDetailScreen from "../../modules/customer/CustomerInDetailsPage/PetsDetails";

import CustomerProductListingScreen from "../../modules/customer/CustomerProductListingScreen";
import CustomerPetListingScreen from "../../modules/customer/CustomerPetListingScreen";
import CustomerBrandPage from "../../modules/customer/CustomerBrandPage";

// ----------------------------------------------------
// Customer Profile / Common
// ----------------------------------------------------

import CustomerProfileScreen from "../../modules/customer/AuthCustomerScreen/CustomerProfileScreen";
import CustomerVideoScreen from "../../modules/customer/CommonScreen/CustomerVideoScreen";

// ----------------------------------------------------
// Services
// ----------------------------------------------------

import GroomingBookingService from "../../modules/customer/CustomerServicesScreens.tsx/GroomingBookingService";
import BookingDateScreen from "../../modules/customer/CustomerServicesScreens.tsx/BookingDateScreen";
import AddGroomingScreen from "../../modules/customer/CustomerServicesScreens.tsx/AddOnGroomingScreen";
import PetTaxiScreen from "../../modules/customer/CustomerServicesScreens.tsx/PetTaxiScreen";
import MobileGroomingScreen from "../../modules/customer/CustomerServicesScreens.tsx/MobileGroomingScreen";
import PetTrainingScreen from "../../modules/customer/CustomerServicesScreens.tsx/PetTrainingScreen";

// ----------------------------------------------------
// Checkout
// ----------------------------------------------------

import CustomerCart from "../../modules/customer/CustomerCheckout/CustomerCart";
import CustomerAddress from "../../modules/customer/CustomerCheckout/CustomerAddress";
import CustomerPaymentScreen from "../../modules/customer/CustomerCheckout/CustomerPaymentScrren";
import CustomerPaymentSuccessScreen from "../../modules/customer/CustomerCheckout/CustomerPaymentSuccessScreen";

// ----------------------------------------------------
// Footer / Public Pages
// ----------------------------------------------------

import CareersPage from "../../modules/customer/Footer/CareersPage";
import ContactusPage from "../../modules/customer/ContactUsPage";
import { BlogPage } from "../../modules/customer/BlogPage";
import BlogDetailsPage from "../../modules/customer/Footer/BlogDetailsPage";

import { CustomerFAQ } from "../../modules/customer/Footer/CustomerFAQ";
import { TermsAndConditionsScreen } from "../../modules/customer/Footer/TermsAndConditionsScreen";

import AboutUsScreen from "../../modules/customer/Footer/AboutUsScreen";
import PrivacyPolicyScreen from "../../modules/customer/Footer/PrivacyPolicyScreen";
import ReturnExchangePolicyScreen from "../../modules/customer/Footer/ReturnExchangePolicyScreen";
import CancellationPolicyScreen from "../../modules/customer/Footer/CancellationPolicyScreen";
import ShippingPolicyScreen from "../../modules/customer/Footer/ShippingPolicyScreen";

import NotFound from "../../modules/NotFound";
import ReelsVideosScreen from "../../modules/customer/CustomerInDetailsPage/ReelsVideosScreen";

const customerRoutes: RouteObject[] = [
  {
    path: "/",
    element: <CustomerPrivateRoute />,

    children: [
      // ==================================================
      // PUBLIC CUSTOMER AREA
      // ==================================================

      {
        path: "/",
        element: <CustomerMainLayout />,

        children: [
          {
            index: true,
            element: <CustomerDashboard />,
          },

          {
            path: "productpage/customerneproductpage/:id",
            element: <CustomerNewProductDetailsPage />,
          },

          {
            path: "productpage/PetDetailScreen/:id",
            element: <PetDetailScreen />,
          },

          {
            path: "productpage/productListingScreen",
            element: <CustomerProductListingScreen />,
          },

          {
            path: "productpage/customerpetlistingscreen",
            element: <CustomerPetListingScreen />,
          },

          {
            path: "productpage/customerbrandpage",
            element: <CustomerBrandPage />,
          },
             {
            path: "productpage/videos",
            element: <ReelsVideosScreen />,
          },
        ],
      },

      // ==================================================
      // REGISTERED CUSTOMER ONLY
      // ==================================================

      {
        element: <CustomerAuthRoute />,

        children: [
          {
            element: <CustomerMainLayout />,

            children: [
              {
                path: "customerprofilescreen",
                element: <CustomerProfileScreen />,
              },

              {
                path: "customervideoscreen",
                element: <CustomerVideoScreen />,
              },
            ],
          },
        ],
      },

      // ==================================================
      // GUEST + REGISTERED CUSTOMER
      // SERVICE PAGES
      // ==================================================

      {
        element: <CustomerMainLayout />,

        children: [
          {
            path: "customergroomingbookingservice",
            element: <GroomingBookingService />,
          },

          {
            path: "customergroomingbookingdatescreen",
            element: <BookingDateScreen />,
          },

          {
            path: "customergroomingbookingdatescreen/addonscreen",
            element: <AddGroomingScreen />,
          },

          {
            path: "pettaxiservice",
            element: <PetTaxiScreen />,
          },

          {
            path: "mobilegroomingservice",
            element: <MobileGroomingScreen />,
          },

          {
            path: "petrainingscreen",
            element: <PetTrainingScreen />,
          },
        ],
      },

      // ==================================================
      // CHECKOUT
      // ==================================================

      {
        path: "cartpage",
        element: <CheckoutLayout />,

        children: [
          // ------------------------------------------------
          // Guest + Registered Customer
          // ------------------------------------------------

          {
            path: "customercartpage",
            element: <CustomerCart />,
          },

          {
            path: "customeraddresspage",
            element: <CustomerAddress />,
          },

          // ------------------------------------------------
          // Registered Customer Only
          // ------------------------------------------------

          {
            element: <CustomerAuthRoute />,

            children: [
              {
                path: "customerpaymentpage",
                element: <CustomerPaymentScreen />,
              },
            ],
          },

          // ------------------------------------------------
          // Payment Gateway Return
          //
          // IMPORTANT:
          // This must NOT be behind CustomerAuthRoute.
          //
          // The payment gateway redirects directly to this URL.
          // The page gets the transaction reference from ?ref=...
          // ------------------------------------------------

          {
            path: "CustomerPaymentSuccessScreen",
            element: <CustomerPaymentSuccessScreen />,
          },
        ],
      },

      // ==================================================
      // PUBLIC FOOTER PAGES
      // ==================================================

      {
        element: <CustomerMainLayout />,

        children: [
          {
            path: "careers",
            element: <CareersPage />,
          },

          {
            path: "blog",
            element: <BlogPage />,
          },

          {
            path: "blog/BlogDetails/:slug",
            element: <BlogDetailsPage />,
          },

          {
            path: "contactus",
            element: <ContactusPage />,
          },

          {
            path: "faq",
            element: <CustomerFAQ />,
          },

          {
            path: "aboutUs",
            element: <AboutUsScreen />,
          },

          {
            path: "privacyPolicy",
            element: <PrivacyPolicyScreen />,
          },

          {
            path: "termsAndConditions",
            element: <TermsAndConditionsScreen />,
          },

          {
            path: "returnAndExchange",
            element: <ReturnExchangePolicyScreen />,
          },

          {
            path: "cancellationPolicy",
            element: <CancellationPolicyScreen />,
          },

          {
            path: "shippingPolicy",
            element: <ShippingPolicyScreen />,
          },
        ],
      },

      // ==================================================
      // NOT FOUND
      // ==================================================

      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default customerRoutes;
